export const BACKEND_URI =  process.env.VUE_APP_BACKEND_URI;
